module.exports = __webpack_public_path__ + "static/media/master.4e298638.svg";